<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="form">
        <div class="filed">
          <div class="filed_label"><span>*</span>申请人员</div>
          <div class="filed_value">{{ userinfo.nickname }}</div>
        </div>
        <div class="filed">
          <div class="filed_label"><span>*</span>所属部门</div>
          <div class="filed_value">{{ userinfo.department }}</div>
        </div>
        <div class="filed">
          <div class="filed_label"><span>*</span>联系电话</div>
          <div class="filed_value">{{ userinfo.phone }}</div>
        </div>
        <div class="filed">
          <div class="filed_label"><span>*</span>所属地点</div>
          <div class="filed_value">{{ object.address }}</div>
        </div>
        <div class="filed">
          <div class="filed_label">
            借伞数量(库存：{{ object.stock - object.lendNum }})
          </div>
          <div class="filed_value">
            <el-input-number
              v-model="num"
              :min="1"
              :max="object.stock - object.lendNum"
            ></el-input-number>
          </div>
        </div>
        <div class="filed">
          <div class="filed_label"><span>*</span>借伞时间</div>
          <div class="filed_value">
            <van-field
              v-model="applyTime"
              placeholder="请选择借伞时间"
              readonly
              clickable
              @click="showPickerApply = true"
              :border="false"
            />
            <van-popup v-model="showPickerApply" position="bottom">
              <van-datetime-picker
                type="datetime"
                v-model="currentTime"
                @confirm="onConfirmApply"
                @cancel="showPickerApply = false"
                :min-date="minDate"
              />
            </van-popup>
          </div>
        </div>
        <div class="filed">
          <div class="filed_label"><span>*</span>预计归还时间</div>
          <div class="filed_value">
            <van-field
              v-model="returnTime"
              placeholder="请选择还伞时间"
              readonly
              clickable
              @click="showPickerReturn = true"
              :border="false"
            />
            <van-popup v-model="showPickerReturn" position="bottom">
              <van-datetime-picker
                type="datetime"
                v-model="currentTimeReturn"
                @confirm="onConfirmReturn"
                @cancel="showPickerReturn = false"
                :min-date="minDate"
              />
            </van-popup>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button class="btn1" @click="submit">确认</el-button>
        <el-button class="btn2" @click="goBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import apis from "@/apis/borrowingAnUmbrella";
export default {
  components: {},
  data() {
    return {
      object: {},
      userinfo: {},
      num: 1,
      applyTime: "",
      showPickerApply: false,
      currentTime: new Date(),
      returnTime: "",
      showPickerReturn: false,
      currentTimeReturn: new Date(),
      minDate: new Date(),
    };
  },
  mounted() {
    const { id } = this.$route.query;
    // if (item) {
    //   this.object = JSON.parse(item);
    //   this.object.stock = Number(this.object.stock);
    //   this.object.lendNum = Number(this.object.lendNum);
    //   this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    // }
    if (id) {
      // this.object.id = id
      this.getUserList(id);
    }
  },
  methods: {
    // 获取借伞详情
    getUserList(id) {
      apis.buDetail({ id }).then((res) => {
        console.log(res, "res-----");
        this.object = res.data;
        this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
        this.object.stock = Number(this.object.stock);
        this.object.lendNum = Number(this.object.lendNum);
      });
    },
    //确认借伞时间
    onConfirmApply(time) {
      this.applyTime = moment(time).format("YYYY-MM-DD HH:mm");
      this.showPickerApply = false;
    },
    //确认归还时间
    onConfirmReturn(time) {
      this.returnTime = moment(time).format("YYYY-MM-DD HH:mm");
      this.showPickerReturn = false;
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    //提交
    submit() {
      if (!this.applyTime) return this.$message.error("请选择借伞时间");
      if (!this.returnTime) return this.$message.error("请选择归还时间");
      const params = {
        buId: this.object.id,
        empNo: this.userinfo.username,
        empName: this.userinfo.nickname,
        num: this.num,
        buTimeStr: moment(this.applyTime).format("YYYY-MM-DD HH:mm:ss"),
        planTimeStr: moment(this.returnTime).format("YYYY-MM-DD HH:mm:ss"),
      };
      apis.buApply(params).then((res) => {
        if (res.code == 200) {
          console.log(res, "resss");
          this.$message.success("申请成功");
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 276px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding: 30px;
  background: #f7f9fa;
  .form {
    background: #fff;
    border-radius: 30px;
    padding: 0 30px;
    .filed {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 0;
      border-bottom: 1px solid #e4e6e8;
      .filed_label {
        color: #969b9e;
        font-size: 28px;
        margin-right: 50px;
        white-space: nowrap;
        span {
          color: #ff4d4d;
        }
      }
      .filed_value {
        color: #000;
        font-size: 28px;
        // font-weight: bold;
        ::v-deep {
          .el-input-number {
            border-radius: 100px;
            width: 190px;
            .el-input-number__decrease,
            .el-input-number__increase {
              border: none;
              background: none;
              color: #4fa27d;
              line-height: 65px;
              width: 70px;
              i {
                font-size: 30px;
                font-weight: bold;
              }
            }
            .el-input--mini .el-input__inner {
              height: 60px;
              line-height: 60px;
              border-radius: 50px;
            }
          }
          .van-cell {
            padding: 0;
            .van-field__control {
              text-align: right;
            }
          }
        }
      }
    }
    .filed:last-child {
      border: none;
    }
  }
  .footer {
    .btn2 {
      border: none;
      background: none;
      color: #969b9e;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 0 0 30px !important;
      border-radius: 15px;
    }
    .btn1 {
      background: #4fa27d;
      color: #fff;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 100px 0 30px;
      border-radius: 15px;
    }
  }
}
</style>
